import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Club from './pages/Club';
import Team from './pages/Team';
import Youth from './pages/Youth';
import Media from './pages/Media';
import Fans from './pages/Fans';
import Contact from './pages/Contact';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import History from './pages/club/History';
import Administration from './pages/club/Administration';
import Financial from './pages/club/Financial';
import Structure from './pages/club/Structure';
import FirstTeam from './pages/team/FirstTeam';
import SecondTeam from './pages/team/SecondTeam';
import CoachingStaff from './pages/team/CoachingStaff';
import TechnicalStaff from './pages/team/TechnicalStaff';
import WomensTeam from './pages/youth/WomensTeam';
import Coaches from './pages/youth/Coaches';
import SocialMedia from './pages/media/SocialMedia';
import PhotoGallery from './pages/media/PhotoGallery';
import VideoGallery from './pages/media/VideoGallery';
import AdminRoutes from './admin/AdminRoutes';
import { ADMIN_BASE_PATH } from './admin/adminConfig';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* Admin Routes */}
            <Route path={`${ADMIN_BASE_PATH}/*`} element={<AdminRoutes />} />
            
            {/* Public Routes */}
            <Route path="/*" element={
              <>
                <Header />
                <main>
                  <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/news" element={<News />} />
                            <Route path="/news/:id" element={<NewsDetail />} />
                            <Route path="/club" element={<Club />} />
                            <Route path="/club/history" element={<History />} />
                            <Route path="/club/administration" element={<Administration />} />
                            <Route path="/club/financial" element={<Financial />} />
                            <Route path="/club/structure" element={<Structure />} />
                            <Route path="/team" element={<Team />} />
                            <Route path="/team/first-team" element={<FirstTeam />} />
                            <Route path="/team/second-team" element={<SecondTeam />} />
                            <Route path="/team/coaching-staff" element={<CoachingStaff />} />
                            <Route path="/team/technical-staff" element={<TechnicalStaff />} />
                            <Route path="/youth" element={<Youth />} />
                            <Route path="/youth/coaches" element={<Coaches />} />
                            <Route path="/youth/womens-team" element={<WomensTeam />} />
                            <Route path="/register" element={<Youth />} />
                            <Route path="/media" element={<Media />} />
                            <Route path="/media/social" element={<SocialMedia />} />
                            <Route path="/media/photos" element={<PhotoGallery />} />
                            <Route path="/media/videos" element={<VideoGallery />} />
                            <Route path="/fans" element={<Fans />} />
                            <Route path="/contact" element={<Contact />} />
                  </Routes>
                </main>
                <Footer />
              </>
            } />
          </Routes>
        </div>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
